<div
  class="ap-navigation-item"
  [class.disabled]="disabled()"
  [class.selected]="selected()"
  [class.active]="active()"
  [attr.aria-expanded]="ariaExpanded()"
  ap-tooltip
  [autoLoad]="false"
  [tooltipContent]="collapsed() ? content() : ''"
  [attr.aria-label]="item().name"
  (click)="clickItem($event)"
  (keyup.enter)="keyupEnter($event)"
  role="none">
  @if (item().prefixIcon) {
    <div class="prefix-content">
      @if (selected()) {
        <span
          class="prefixIcon appkit-icon Appkit4-icon icon-{{
            item().prefixCollapsedIcon
          }}-fill"
          aria-hidden="true"></span>
      } @else {
        <span
          class="prefixIcon appkit-icon Appkit4-icon icon-{{
            item().prefixIcon
          }}-outline"
          aria-hidden="true"></span>
      }
    </div>
  }
  <span class="item-content" aria-hidden="true">{{ item().name }}</span>

  @if (item().suffixIcon) {
    <span
      class="suffix-icon appkit-icon Appkit4-icon icon-{{
        item().suffixIcon
      }}-outline"
      [class.rotate]="item().open">
    </span>
  }
  <ng-content></ng-content>
</div>
